// extracted by mini-css-extract-plugin
module.exports = {"link":"ResponsiveBurger_link___hjjY"};